export default __webpack_public_path__ + "static/media/Img6.59982f12.jpg";